<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('coa')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onAdd(1)"><i class="fa fa-plus-circle"></i> {{$t('add_new')}}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onAdd(2)"><i class="fa fa-file-excel-o"></i> {{$t('import')}}</button>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="d-flex" style="gap: 8px;">
                        <div class="form-group">
                            <label class="form-control-label blue">ស្វែងរក...</label>
                            <input type="text" class="form-control form-control-sm" v-model="query.Text" @keypress.enter="toList" placeholder="លេខកូដ ឈ្មោះ" />
                        </div>
                        <div class="form-group">
                            <label class="form-control-label blue">ប្រភេទ</label>
                            <select class="form-control form-control-sm" v-model="query.AccountTypeId" @change="toList">
                                <option value="">{{$t('all')}}</option>
                                <option v-for="ret in accountTypes" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-control-label blue">&nbsp;</label>
                            <div><button type="button" class="btn btn-outline-primary btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button></div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor">
                        <thead class="table-primary">
                            <tr>
                                <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                <th>{{ $t('account_name')}}</th>
                                <th>{{ $t('account_no')}}</th>
                                <th>{{ $t('account_type') }}</th>
                                <th>{{ $t('description') }}</th>
                                <th class="text-center">{{ $t('sort')}}</th>
                                <th style="width: 55px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="viewType==0">
                                <tr v-for="(ret, index) in records" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.Name}}</td>
                                    <td>{{ret.Num}}</td>
                                    <td>{{ret.AccountTypeName}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td class="text-center">{{ret.Sort}}</td>
                                    <td>
                                        <div class="cell-action">
                                            <button type="button" class="btn btn-outline-primary btn-sm btn-xs" @click="onEdit(ret)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                            <button type="button" class="btn btn-outline-danger btn-sm btn-xs" @click="onDelete(ret.Id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <template v-for="(record,lindex) in recordGroups">
                                    <tr :key="(lindex+'col')">
                                        <th colspan="7">{{record.AccountType}}</th>
                                    </tr>
                                    <tr v-for="(ret, index) in record.Accounts" :key="lindex+'-'+index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.Name}}</td>
                                        <td>{{ret.Num}}</td>
                                        <td>{{ret.AccountTypeName}}</td>
                                        <td>{{ret.Description}}</td>
                                        <td class="text-center">{{ret.Sort}}</td>
                                        <td>
                                            <div class="cell-action">
                                                <button type="button" class="btn btn-outline-primary btn-sm btn-xs" @click="onEdit(ret)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                                <button type="button" class="btn btn-outline-danger btn-sm btn-xs" @click="onDelete(ret.Id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                      hide-goto-end-buttons
                                      @change="paging($event)" />
                    </div>
                </div>
            </div>
        </div>
        <CoaForm ref="form" :value="model" @save="onSave"></CoaForm>
        <CoaImport ref="formImport" @done="onDoned"></CoaImport>
    </div>
</template>
<script>
    import CoaForm from './Components/CoaFormModal';
    import CoaImport from './Components/CoaImportModal';
    import Swal from 'sweetalert2';
    export default {
        components: { CoaForm, CoaImport },
        data() {
            return {
                query: {
                    Text: '',
                    AccountTypeId: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    IsGroup: false,
                    CompanyId: this.$store.state.company.Id
                },
                records: [],
                recordGroups: [],
                accountTypes: [],
                viewType: 0,
                model: {
                    Num: '',
                    AccountTypeId: '',
                    AccountTypeName: '',
                    Name: '',
                    Sort: 1
                }
            };
        },
        created: function () {
            this.viewType = this.query.IsGroup ? 1 : 0;
            this.toList();
            this.typeList();
        },
        methods: {
            toList() {
                var loading = this.$loading.show();
                this.$api().post('accounting/accounts', this.query).then(res => {
                    if (this.$isValid(res)) {
                        if (this.viewType == 0) {
                            this.records = res.data.Json.Accounts;
                        } else {
                            this.recordGroups = res.data.Json.AccountGroups;
                        }
                        this.query.Total = res.data.Total;
                    }
                }).finally(function () { loading.hide(); });
            },
            typeList() {
                var loading = this.$loading.show();
                this.$api().post('accounting/types', {}).then(res => {
                    if (this.$isValid(res)) {
                        this.accountTypes = res.data.Json.Types;
                    }
                }).finally(function () { loading.hide(); });
            },
            viewTypeChange(n) {
                this.viewType = n;
                this.query.IsGroup = (n == 0) ? false : true;
                this.toList();
            },
            paging(e) {
                this.query.Page = e;
                this.toList();
            },
            onDelete(id) {
               Swal.fire({
                   title: 'Are you sure?',
                   text: "You won't be able to revert this!",
                   icon: 'warning',
                   showCancelButton: true,
                   confirmButtonColor: '#3085d6',
                   cancelButtonColor: '#d33',
                   confirmButtonText: 'Yes, delete it!'
               }).then((result) => {
                   if (result.value) {
                       this.$api().post('accounting/account-delete', { Id: id }).then(res => {
                           if (this.$isValid(res)) {
                               this.toList();
                               Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
                           }
                       });
                   }
               });
            },
            onAdd(n) {
                if (n == 1) {
                    this.model = {
                        Num: '',
                        AccountTypeId: '',
                        AccountTypeName: '',
                        Name: '',
                        Sort: 1
                    };
                    this.$refs.form.$refs.innerform.show();
                }
                else if (n == 2) this.$refs.formImport.$refs.innerform.show();
            },
            onSave: function (ret) {
                this.model = JSON.parse(JSON.stringify(ret));
                this.model.CompanyId = this.$store.state.company.Id;
                var loading = this.$loading.show();
                this.$api().post('accounting/account-save', this.model).then(res => {
                    if (this.$isValid(res)) {
                        this.toList();
                        this.$refs.form.$refs.innerform.hide();
                    }
                }).finally(function () {
                    loading.hide();
                });
            },
            onEdit(ret) {
                this.model = JSON.parse(JSON.stringify(ret));
                this.$refs.form.$refs.innerform.show();
            },
            onDoned(){
                this.$refs.formImport.$refs.innerform.hide();
                this.toList();
            }
        }
    };
</script>
<style scoped>
    .btn-delete {
        height: 20px;
        width: 22px;
        line-height: 0;
    }
</style>
